import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import { Select, Spin } from "antd";
import { isShiftPlanEnabled } from "../../../../feature-module/utils/commonUtils";
const EditRegistration = ({ editObj, onUpdateSuccess, onClose, isOpen }) => {
  const [editObjData, setEditObjData] = useState({});
  const [branchesData, setBranchesData] = useState([]);
  const [deptData, setDeptData] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [shifts, setShifts] = useState([]);
  const [loadingShift, setLoadingShift] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (editObj) {
      setEditObjData(editObj);
    }
  }, [editObj]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchBranches = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (!response.ok) {
            throw new Error("Failed to fetch branches");
          }

          const data = await response.json();

          if (data && data.status === true && Array.isArray(data.ResultData)) {
            setBranchesData(data.ResultData);
          } else {
            console.error("Invalid branch response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching branches:", error.message);
        }
      };

      fetchBranches();
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchDepartments = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (!response.ok) {
            throw new Error("Failed to fetch departments");
          }

          const data = await response.json();

          if (data && data.status === true && Array.isArray(data.ResultData)) {
            setDeptData(data.ResultData);
          } else {
            console.error("Invalid department response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching departments:", error.message);
        }
      };

      fetchDepartments();
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if (tokenData && superIdData && isShiftPlanEnabled()) {
      setLoadingShift(true);
      fetch(
        `${ROLL_CALL_API_BASE_URL}portal/shifts/getShiftsTypes?superid=${superIdData}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      )
        .then((res) => res.json())
        .then((res) => setShifts(res.ResultData || []))
        .catch((error) => console.error("Error fetching shifts:", error))
        .finally(() => setLoadingShift(false));
    }
  }, [tokenData, superIdData]);

  const shiftOptions =
    shifts &&
    shifts.map((item) => ({
      value: item.shiftid,
      label: `${item.Name} `,
    }));

  const handleShiftChange = (value) => {
    setEditObjData((prev) => ({
      ...prev,
      ShiftId: value,
    }));
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditObjData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // const handleDepartmentChange = (value) => {
  //   setEditObjData((prevData) => ({
  //     ...prevData,
  //     Departmentid: selectedDepartmentId,
  //   }));
  // };
  const handleDepartmentChange = (value) => {
    setEditObjData((prev) => ({
      ...prev,
      DepartmentId: value,
    }));
  };

  const handleBranchChange = (selectedBranchId) => {
    setEditObjData((prevData) => ({
      ...prevData,
      BranchId: selectedBranchId,
    }));
  };

  const branchOptions =
    branchesData &&
    branchesData?.map((item) => ({
      value: item.branchid,
      label: item.Name,
    }));

  const departmentOptions =
    deptData &&
    deptData?.map((item) => ({
      value: item.DepartmentId,
      label: item.Name,
    }));

  const handleUpdateRegistration = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    const requestBody = {
      superid: superIdData,
      badge: editObjData?.Badge,
      username: editObjData?.UserName,
      dateofbirth: editObjData?.DateOfBirth,
      designation: editObjData?.Designation,
      cardid: editObjData?.CardId,
      mobile: editObjData?.Mobile,
      rfid: editObjData?.RFID,
      gender: editObjData?.Gender,
      branchid: editObjData?.BranchId,
      departmentid: editObjData?.DepartmentId,
      doj: editObjData?.DateOfJoining,
      regid: editObjData?.RegId,
      emailid: editObjData?.EmailId || "",
      shiftid: editObjData?.ShiftId || null,
    };
    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/emp/updateEmployee`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify(requestBody),
        },
      );

      const responseData = await response.json();

      if (responseData.status) {
        const updatedEmployee = responseData.ResultData[0];
        Swal.fire({
          title: "Success",
          text: responseData.Message || "Employee updated successfully",
          icon: "success",
        }).then(() => {
          onUpdateSuccess(updatedEmployee);

          onClose();
        });
      } else {
        Swal.fire({
          title: "Error",
          text: responseData.Message || "Failed to update employee.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error updating employee:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to update employee.",
        icon: "error",
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleClose = () => {
    setEditObjData(editObj);
    onClose();
  };

  // useEffect(() => {
  //   if (departmentOptions?.length && editObjData?.DepartmentId) {
  //     setEditObjData((prev) => ({
  //       ...prev,
  //       DepartmentId: prev.DepartmentId,
  //     }));
  //   }
  // }, [departmentOptions]);

  useEffect(() => {
    if (!departmentOptions?.length) return;

    setEditObjData((prev) => {
      if (!prev?.DepartmentId) return prev;

      // ✅ NO CHANGE → no re-render
      return prev;
    });
  }, [departmentOptions]);

  return (
    <>
      {isOpen && (
        <div>
          <style>
            {`
        @media (max-width: 576px) {
          #offcanvasRightEditReg {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightEditReg {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightEditReg {
            width: 40% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightEditReg {
            width: 28% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightEditReg {
            width:20% !important;
          }
        }
        `}
          </style>
          {submitLoading && (
            <div
              className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
              style={{
                zIndex: 1050,
                backdropFilter: "blur(4px)",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
              }}
            >
              <Spin size="large" tip="Processing..." />
            </div>
          )}

          {/* Backdrop */}
          <div className="offcanvas-backdrop fade show" onClick={onClose} />
          <div
            className="offcanvas offcanvas-end show"
            id="offcanvasRightEditReg"
            style={{ visibility: "visible" }}
          >
            <div className="offcanvas-header">
              <h4>Edit Registration</h4>
              <button
                type="button"
                className="btn-close text-reset"
                // data-bs-dismiss="offcanvas"
                onClick={handleClose}
                aria-label="Close"
              />
            </div>
            <hr className="m-0 p-0" />
            <div className="offcanvas-body">
              <form onSubmit={handleUpdateRegistration}>
                <div className="content">
                  <div className="row">
                    {[
                      { label: "Name", name: "UserName", type: "text" },
                      { label: "Emp ID", name: "Badge", type: "text" },
                      { label: "Biometric", name: "CardId", type: "text" },
                      { label: "RFID", name: "RFID", type: "text" },
                      { label: "Mobile", name: "Mobile", type: "text" },
                      { label: "Email ID", name: "EmailId", type: "text" },
                      { label: "DOB", name: "DateOfBirth", type: "date" },
                      { label: "DOJ", name: "DateOfJoining", type: "date" },
                      {
                        label: "Designation",
                        name: "Designation",
                        type: "text",
                      },
                    ]?.map((input) => (
                      <div key={input.name} className="col-6 g-2">
                        <label className="form-label">{input.label}</label>
                        {/* <input type={input.type} className="form-control" name={input.name} value={editObjData[input.name] || ""} onChange={handleInputChange} /> */}
                        <input
                          type={input.type}
                          className="form-control"
                          name={input.name}
                          // disabled={input.name === "UserName"}
                          value={
                            input.type === "date" && editObjData[input.name]
                              ? new Date(editObjData[input.name])
                                  .toISOString()
                                  .split("T")[0]
                              : editObjData[input.name] || ""
                          }
                          onChange={handleInputChange}
                        />
                      </div>
                    ))}
                    <div className="col-6 g-2">
                      <label className="form-label">Gender</label>
                      <select
                        className="form-select"
                        name="Gender"
                        value={editObjData?.Gender?.toString() || ""}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="" disabled>
                          Select Gender
                        </option>
                        <option value="1">Male</option>
                        <option value="0">Female</option>
                      </select>
                    </div>
                    <div className="col-6 g-2">
                      <label className="form-label">Department</label>
                      <Select
                        showSearch
                        placeholder="Choose Department"
                        // value={editObjData?.DepartmentId || null}
                        value={editObjData?.DepartmentId ?? undefined}
                        onChange={handleDepartmentChange}
                        options={departmentOptions}
                        style={{ width: "100%", height: "35px" }}
                      />
                    </div>
                    {isShiftPlanEnabled() && (
                      <div className="col-6 g-2">
                        <label className="form-label">Shift</label>
                        <Select
                          showSearch
                          allowClear
                          placeholder="Select Shift"
                          loading={loadingShift}
                          value={
                            editObjData?.ShiftId
                              ? editObjData.ShiftId
                              : undefined
                          }
                          onChange={handleShiftChange}
                          onClear={() => handleShiftChange(null)}
                          options={shiftOptions}
                          filterOption={(input, option) =>
                            option?.label
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          style={{ width: "100%", height: "35px" }}
                        />
                      </div>
                    )}

                    <div className="col-6 d-none g-2">
                      <label className="form-label">Branch</label>
                      <Select
                        showSearch
                        placeholder="Choose Branch"
                        value={Number(editObjData?.BranchId) || null}
                        onChange={handleBranchChange}
                        options={branchOptions}
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  <div className=" d-flex justify-content-end mt-3">
                    <div className="d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-secondary "
                        onClick={handleClose}
                        aria-label="Close"
                      >
                        Cancel
                      </button>
                    </div>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <div className=" d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={submitLoading}
                      >
                        {/* {submitLoading ? "Updating..." : "Submit"} */}
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      ;
    </>
  );
};

EditRegistration.propTypes = {
  editObj: PropTypes.object.isRequired,
  onUpdateSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.func.isRequired,
};

export default EditRegistration;
